export enum FeatureFlag {
  GenerateAnalytics = 'generate_analytics',
  GenerateAnalyticsBenchAnalysisToeCrest = 'ga_bench_analysis_toe_crest',
  GenerateAnalyticsHaulRoadGradient = 'ga_haul_road_gradient',
  GenerateAnalyticsHaulRoadWidth = 'ga_haul_road_width',
  GenerateAnalyticsDrainageAnalytics = 'ga_drainage_analytics',
  GenerateAnalyticsSlopeStability = 'ga_slope_stability',
  GenerateAnalyticsLandUseLandCover = 'ga_land_use_land_cover',
  GenerateAnalyticsSuperElevation = 'ga_super_elevation',
  HaulRoadAnalytics = 'haul_road_analytics',
  MBTiles = 'mbtiles',
  PowerBIReport = 'power_bi_report',
  Processing = 'processing',
  ProcessingWorkflow = 'processing_workflow',
  SlopeMap = 'slope_map',
  BenchToeCrestDetection = 'bench_toe_crest_detection',
  BuildingFootprintsOrRoofTopsDetection = 'building_footprints_or_roof_tops_detection',
  DrainageAnalysis = 'drainage_analysis',
  HeapDetection = 'heap_detection',
  PondsAndLakesDetection = 'ponds_and_lakes_detection',
  RiversAndStreamsDetection = 'rivers_and_streams_detection',
  TreeCanopiesDetection = 'tree_canopies_detection',
  MetalledRoadsDetection = 'metalled_roads_detection',
  UnmetalledRoadsDetection = 'unmetalled_roads_detection',
  BoreholeDetection = 'borehole_detection',
  FoundationPilingDetection = 'foundation_piling_detection',
  PurlinDetection = 'purlin_detection',
  SolarPanelDetection = 'solar_panel_detection',
  DrillHoleDetection = 'drill_hole_detection',
  SwipeMap3d = 'swipe_map_3d',
  StoreFiles = 'store_files',
  PointCloud = 'point_cloud',
  ComplianceAssessment = 'compliance_assessment',
  AereoSupportAIBot = 'aereo_support_ai_bot',
  VegetationCoverDetection = 'vegetation_cover_detection',
  TerrainCleanup = 'terrain_cleanup',
  DrillAndBlastRequest = 'drill_and_blast_request',
  GenerateDTMRequest = 'generate_dtm_request',
  GenerateDEM = 'generate_dem',
  CrossSection = 'cross_section_generation',
  TwoFactorAuthentication = 'two_factor_authentication',
  AIAssistedDigitization = 'ai_assisted_digitization',
  ContourGeneration = 'contour_generation',
  ElevationProfile = 'elevation_profile',
  VolumeCalculation = 'volume_calculation',
  SubtractDEM = 'subtract_dem',
  ProductivityDashboard = 'productivity_dashboard',
  CAD = 'cad',
  PPKGeotagGeneration = 'ppk',
}
